import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { AnalyticTable } from '../AnalyticTable';
import { createTableMetrics } from './utils';

const columns = [
  { label: 'By Country' },
  { isNumeric: true, label: 'Utility' },
  { isNumeric: true, label: 'Marketing' },
];

export const WhatsAppAnalyticTable = () => {
  const {
    billingPeriodMetrics: { ByOrgProjectWhatsAppTemplateCategoryRecipientCountry = {} } = {},
  } = useQueryContext();

  const tableMetricsWithSum = createTableMetrics(
    ByOrgProjectWhatsAppTemplateCategoryRecipientCountry,
  );

  return (
    <AnalyticTable columns={columns} gridLayout="1fr 160px 160px" metrics={tableMetricsWithSum} />
  );
};
